module.exports = __webpack_public_path__ + "static/media/metamask_icon.f5ff58a9.png";